import React, { useState, useEffect } from 'react';
import './index.scss';
import Lottie from 'lottie-react';

const UnlimitedChat251006: React.FC = () => {
    const [animationData, setAnimationData] = useState(null);

    useEffect(() => {
        fetch('https://static.koreanmate.app/notice/251006-unlimitchat/applicaiton.json')
            .then(response => response.json())
            .then(data => setAnimationData(data))
            .catch(error => console.error('Error loading animation:', error));
    }, []);

    return (
        <div className="unlimited-chat-page">

            <div className="top-section">
                <div className="lottie-container">
                    <Lottie
                        animationData={animationData}
                        loop={true}
                        autoplay={true}
                        style={{ width: '100%', height: '100%' }}
                    />
                </div>
            </div>

            <div className="smart-mate-container">
                <p className="smart-mate-title">
                    {`Belajar bahasa Korea dengan Mate yang `}<span className="highlight">{`lebih pintar dan ramah`}</span>{`, dan terima `}<span className="highlight">{`gambar Mate tanpa batas!`}</span>
                </p>

                <div className="chat-detail-container">
                    <img src="https://static.koreanmate.app/notice/251006-unlimitchat/chatdetail.png" alt="Chat Detail Interface" className="chat-detail-image" />
                </div>
            </div>

            <div className="chat-promotion-container">
                <p className="chat-promotion-title">
                    {`Jika `}<span className="highlight">{`versi aplikasi adalah 1.6.1`}</span>{`, nikmati chat tanpa batas dengan Mate!`}
                </p>

                <div className="chat-images-container">
                    <img src="https://static.koreanmate.app/notice/251006-unlimitchat/chatimg.png" alt="Chat Interface" className="chat-image" />
                </div>
            </div>

            <div className="version-check-container">
                <p className="version-title">
                    {`Silakan cek `}<span className="highlight">{`versi aplikasi`}</span>{` Anda!`}
                </p>

                <div className="image-container">
                    <img src="https://static.koreanmate.app/notice/251006-unlimitchat/bottom_of_my.png" alt="App Version Check" className="main-image" />
                </div>

                <div className="description-text">
                    <p>{`Jika Anda menggulir ke bawah pada tab My Page, Anda dapat memeriksa versinya. Untuk menikmati chat tanpa batas, versi aplikasi harus 1.6.1.`}</p>
                </div>
            </div>
        </div>
    );
};

export default UnlimitedChat251006;